import { useState, useCallback } from "react";
import { useSelector } from "react-redux";

import { getApi } from "../../../api/api";
import { selectClusterList } from "../../../store/slices/clusterListSlice";
import { BonusBalanceInterface } from "../../../common/types/interfaces";

export const useBonuses = (clusterId: number) => {
  const api = getApi();
  const clusters = useSelector(selectClusterList);

  const cluster = clusters.find((c) => Number(c.id) === clusterId);

  const [balance, setBalance] = useState(0);
  const [totalSpent, setTotalSpent] = useState(0);
  const [bonusPercent, setBonusPercent] = useState(0);
  const [bonusesToSpend, setBonusesToSpend] = useState<number>(0);
  const [loading, setLoading] = useState(false);

  const loadBonuses = useCallback(async () => {
    if (!clusterId) return;
    try {
      setLoading(true);
      const result = await api.getBonusBalances();
      const clusterBonus = (result || []).find(
        (b: BonusBalanceInterface) => Number(b.clusterId) === Number(clusterId),
      );

      setBalance(Math.floor(clusterBonus?.balance || 0));
      setTotalSpent(Math.floor(clusterBonus?.totalSpent || 0));
      setBonusPercent(Number(clusterBonus?.bonusPercent || 0));
    } catch {
      setBalance(0);
      setTotalSpent(0);
      setBonusPercent(0);
    } finally {
      setLoading(false);
    }
  }, [api, clusterId]);

  const writeOffPercent = Number(cluster?.writeOff || 0);
  const bonusRules = (cluster?.bonuses || []) as {
    level: number;
    value: number;
  }[];

  return {
    balance,
    totalSpent,
    bonusPercent,
    writeOffPercent,
    bonusRules,
    bonusesToSpend,
    setBonusesToSpend,
    loadBonuses,
    loading,
  };
};
